import React, { CSSProperties } from 'react';
import styles from './CollectionOption.module.css';
import Image from '../../../../../../../ui/Image/Image';
import Skeleton from '../../../../../../../ui/Skeleton/Skeleton';
import { ProtectedByUserGroups } from '../../../../../../Auth/components/ProtectedByUserGroup/ProtectedByUserGroups';
import Button from '../../../../../../../ui/Buttons/Button/Button';
import { ReactComponent as EditIcon } from '../../../../../../../assets/EditIcon.svg';
import { SelectBoxOptionWithId } from '../../../../../../../ui/DataEntry/SelectBox/SelectBox.types.';

type CollectionOptionProps = {
    item: SelectBoxOptionWithId | undefined;
    onClick: (item: SelectBoxOptionWithId | undefined) => void;
    onEdit?: (item: SelectBoxOptionWithId) => void;
    loading?: boolean;
    style?: CSSProperties;
    setShowDropdown: (show: boolean) => void;
};

const CollectionOption = ({ item, loading, onClick, onEdit, style, setShowDropdown }: CollectionOptionProps) => {
    const handleEditClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (typeof onEdit !== 'function' || !item) {
            return;
        }

        onEdit(item);
        setShowDropdown(false);
    };

    return (
        <div className={styles.option} onClick={() => onClick(item)} style={style}>
            <Image loading={loading} className={styles.image} src={item?.picture} alt="" />
            <div className={styles.optionContent}>
                <p className={styles.label}>{loading ? <Skeleton /> : item?.name}</p>
                <p className={styles.subtitle}>{loading ? <Skeleton /> : item?.subtitle}</p>
            </div>
            <ProtectedByUserGroups groups={['catalogue_editor']}>
                <Button className={styles.editButton} ariaLabel="Edit collection" onClick={handleEditClick}>
                    <EditIcon />
                </Button>
            </ProtectedByUserGroups>
        </div>
    );
};

export default CollectionOption;
